/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getShipments } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetShipmentList = (filters: any, options?: UseQueryOptions) =>
  useQuery({
    queryKey: shipmentQueryKeys.shipmentListing(filters),
    queryFn: ({ signal }) => getShipments({ params: filters, signal }).then((res) => res.data),
    ...options,
  });
